<template>
  <main-layout
    :title="$t('Payments & Billing')"
    :containerFluid="false"
  >
    <template v-slot:titleActions>
      <guide-help-button
        v-if="showBillingGuideButton"
        guide-name="billing"
        button-text="Help guide"
      />
    </template>
    <template v-slot:body>
      <div class="mt-8">
        <subscriptions />
      </div>
      <div class="mt-16">
        <billing />
      </div>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Subscriptions from '@/components/subscriptions/Subscriptions.vue';
import Billing from '@/components/subscriptions/Billing.vue';
import GuideHelpButton from '@/components/GuideHelpButton.vue';

export default {
  components: {
    Subscriptions,
    Billing,
    GuideHelpButton,
  },
  mounted() {
    this.$title = this.$t('My Subscriptions');
  },
  computed: {
    ...mapGetters(['user']),
    showBillingGuideButton() {
      if (!this.user) {
        return false;
      }

      return this.user.subscriptionsCount || this.user.transactionsCount;
    },
  },
};
</script>
